import {autoinject, bindable, bindingMode, customElement} from 'aurelia-framework';
import {allCountries, Country} from "../models";
import {CartService} from "../cart-service";

@customElement('address-form')
@autoinject
export class AddressForm {
  @bindable({defaultBindingMode: bindingMode.twoWay}) address: Address;
  @bindable({defaultBindingMode: bindingMode.twoWay}) valid: boolean;

  formErrors: FormErrors = new FormErrors();
  countries: Array<Country>;

  constructor(private cs: CartService) {
    this.countries = allCountries;
  }

  addressChanged(): void {
    this.validateInput();
  }

  private validateName(): void {
    this.formErrors.nameErrorMessage = !this.cs.isNameValid(this.address.first_name) && "Gib bitte deinen Vornamen an";
    this.validateInput();
  }

  private validateLastName(): void {
    this.formErrors.lastnameErrorMessage = !this.cs.isLastNameValid(this.address.last_name) && "Gib bitte deinen Nachnamen an";
    this.validateInput();
  }

  private validateEmail(): void {
    this.formErrors.emailErrorMessage = !this.cs.isEmailValid(this.address.e_mail) && "Gib bitte eine korrekte E-Mail-Adresse an";
    this.validateInput();
  }

  private validateStreet(): void {
    this.formErrors.streetErrorMessage = !this.cs.isStreetValid(this.address.street) && "Gib bitte deine Straße & Hausnummer an";
    this.validateInput();
  }

  private validateZip(): void {
    this.formErrors.zipErrorMessage = !this.cs.isZipValid(this.address.country, this.address.zip) && "Gib bitte eine korrekte Postleitzahl an";
    this.validateInput();
  }

  private validateCity(): void {
    this.formErrors.cityErrorMessage = !this.cs.isCityValid(this.address.city) && "Gib bitte deine Stadt an";
    this.validateInput();
  }

  private validateCountry(): void {
    this.formErrors.countryErrorMessage = !this.cs.isCountryValid(this.address.country) && "Bitte wähle ein Land aus!";
    this.validateInput();
  }

  private validateInput(): void {
    this.valid = this.cs.validateAddress(this.address);
  }
}

export class Address {
  first_name: string;
  last_name: string;
  street: string;
  e_mail: string;
  city: string;
  zip: string;
  country: string;
}

export class FormErrors {
  countryErrorMessage: string;
  zipErrorMessage: string;
  nameErrorMessage: string;
  lastnameErrorMessage: string;
  emailErrorMessage: string;
  streetErrorMessage: string;
  cityErrorMessage: string;
}